import * as Yup from "yup";


export const DoctorSchema = Yup.object({
    name: Yup.string().required(" Enter Doctor Name"),
    mobile: Yup.string().min(10, 'Must be exactly 10 digits').required("Enter Mobile Number").matches(/^(((0|((\+)?91(\-)?))|((\((\+)?91\)(\-)?)))?[6-9]\d{9})?$/, "Invalid Number"),
    gender: Yup.string().required(" Select Gender"),
    qualification: Yup.string().required(" Enter Qualification"),
    specilization: Yup.string().required(" Enter Specilization"),
    experience: Yup.number().required('Experience is required'),
    doctorImage: Yup.mixed().required('Image is required'),
    status: Yup.string().required(" Select Status"),
});